<template>
	<div>
		<v-alert
			class="pa-3 mb-0"
			border="top"
			colored-border
			:color="color"
		>
			<v-row class="ma-0" justify="space-between">
				<div class="title-text">Settings change log</div>
				<div>
					<v-icon @click="$emit('close')">mdi-close</v-icon>
				</div>
			</v-row>
			<v-row v-if="error_msg.length !== 0" class="ma-0">
				<v-col cols="12" class="px-0">
					<v-alert type="error" class="mb-0">
						{{ error_msg }}
					</v-alert>
				</v-col>
			</v-row>
			<ProgressLinear v-if="loading"/>
			<v-row v-if="!loading && warning_text.length !==0" class="ma-4">
				<div>{{ warning_text }}</div>
			</v-row>
			<template v-if="!loading">
				<div class="log-wrap-container">
					<div class="log-wrap">
						<v-list-item v-for="log of listByGroup[page-1]" :key="log.id" two-line class="px-2">
							<v-list-item-content >
								<v-list-item-title>
									<v-row v-if="!$vuetify.breakpoint.smAndDown" class="ma-0 log-title-text" justify="space-between">
										<div>Changed by: {{ log.created_by }}</div>
										<div>{{ log.created_on_date }}&nbsp;at&nbsp;{{ log.created_on_time }}</div>
									</v-row>
									<v-row v-if="$vuetify.breakpoint.smAndDown" class="ma-0 log-title-text">
										<div>Changed by: {{ log.created_by }}</div>
									</v-row>
									<v-row v-if="$vuetify.breakpoint.smAndDown" class="ma-0 log-title-text">
										<div>{{ log.created_on_date }}&nbsp;at&nbsp;{{ log.created_on_time }}</div>
									</v-row>
								</v-list-item-title>
								<v-list-item-subtitle v-for="(log, index) of log.logs" :key="`${log.id}_log_${index}`">
									<span :class="log[1] === true ? 'log-diff-color my-1':'my-1'">{{ log[0] }}</span>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</div>
				</div>
				<v-row class="ma-0" :justify="$vuetify.breakpoint.smAndDown? 'start':'end'" :align="`center`">
					<v-pagination
						v-model="page"
						:color="color"
						:length="getPaginationTotal()"
						:total-visible="$vuetify.breakpoint.xs ? 3: 5"
						circle
					></v-pagination>
					<div class="pagination-text">show</div>
					<div class="pagination-text-page">&nbsp;{{ countPerpage}}/page</div>
					<v-menu offset-y nudge-top="120" nudge-left="10">
						<template v-slot:activator="{ on, attrs }">
							<div class="ml-1" v-bind="attrs" v-on="on">
								<Down class="down" :color="'#192A3E80'"/>
							</div>
						</template>
						<v-list>
							<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" @click="onClickOption(pageOption)">
								{{pageOption}}
							</v-list-item-title>
						</v-list>
					</v-menu>
				</v-row>
			</template>
		</v-alert>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import Down from '@/components/icons/down';

import config from "@/config.js";
import moment from 'moment';

export default {
	name: 'SettingChangeLog',
	props: {
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			error_msg: '',
			loading: false,
			warning_text: '',
			log_list: [],

			page: 1,
			countPerpage: 5,
			pageOptions: config.pageOptions,
		}
	},
	computed: {
		listByGroup() {
			let array = [];

			if (this.countPerpage !== 0 && this.log_list.length !== 0) {
				array = this.log_list.reduce((r, e, i) => (i % this.countPerpage ? r[r.length - 1].push(e) : r.push([e])) && r, []);
			}

			return array
		}
	},
	components: {
		ProgressLinear,
		Down
	},
	created() {
		this.getLogs();
	},
	methods: {
		getLogs() {
			this.loading = true;
			const url = '/api/config/setup/job/change_logs';

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						if (data.length === 0) {
							this.warning_text = 'No settings change logs';
						} else {
							const data_tmp = [];
							data.forEach(t => {
								t['created_on_date'] = moment(t.created_on).format('DD MMM YYYY');
								t['created_on_time'] = moment(t.created_on).format('hh:mm a');

								const log_text_arr = t.log_text.split('\n');
								t['logs'] = log_text_arr.map(l => { return [l, false] });							

								data_tmp.push(t);
							});
						 
							data_tmp.sort((a, b) => {
								const A = new Date(a.created_on);
								const B = new Date(b.created_on);

								if (A.getTime() === B.getTime()) {
									return B.id - A.id;
								} else {
									return B.getTime() - A.getTime();
								}
							});

							// to compare the diff of first one and second one
							const compare_item = data_tmp[1].logs;
							data_tmp[0].logs.forEach((log, index) => {
								if (log[0] !== (compare_item[index])[0]) {
									log[1] = true;
								}
							});

							this.log_list = data_tmp;
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getPaginationTotal() {
			return Math.ceil(this.log_list.length / this.countPerpage);
		},
		onClickOption(option) {
			this.countPerpage = option;
		},
	}
}
</script>
<style lang="scss" scoped>
.log-wrap-container {
	max-height: 480px;
	overflow: auto;
}
.log-wrap {
	height: 90%;
}
.title-text {
	font-family: Roboto;
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	color: #605AF6;
}
.log-title-text {
	font-family: Roboto;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	color: #4742C6;
}
.log-diff-color {
	font-weight: 500;
	color:#192A3E;
}

.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	
}
.pagination-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	color: #192A3E80;
}
.pagination-text-page {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	color: #192A3E80;
}
.down {
	width: 12px;
	height: 12px;
	&:hover {
		cursor: pointer;
	}
}
::v-deep {
	.option-text {
		margin: 0 4px;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		color: #192A3E;
		&:hover {
			cursor: pointer;
		}
	}
	.v-pagination__item {
		height: 20px;
		min-width: 20px;
		font-size: 12px;
	}
	.v-pagination__navigation {
		height: 20px;
		width: 20px;
	}
}
</style>